"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cloneDigitalData = cloneDigitalData;
exports.maskEmail = maskEmail;
exports.maskString = maskString;
exports.pageViewMutation = pageViewMutation;
var _enums = _interopRequireDefault(require("./types/enums"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function cloneDigitalData(digitalData) {
  return JSON.parse(JSON.stringify(digitalData));
}
function pageViewMutation(event, digitalData) {
  if (event.name !== _enums.default.PAGE_VIEW && event.name !== _enums.default.VIRTUAL_PAGE_VIEW) {
    return digitalData;
  }
  var newDigitalData = cloneDigitalData(digitalData);
  var _event$data = event.data,
    pageId = _event$data.pageId,
    pathname = _event$data.pathname,
    attributes = _event$data.attributes;
  newDigitalData.page.pageInfo = {
    pageId: pageId,
    pathname: pathname,
    attributes: attributes
  };
  return newDigitalData;
}
function maskString(str) {
  if (!str) return '';
  if (str.length === 1) return '*';
  if (str.length === 2) return '**';
  return str.replace(/^(.)(.*)(.)$/, function (_, a, b, c) {
    return a + b.replace(/./g, '*') + c;
  });
}
function maskEmail(email) {
  if (!email) return '';
  return email.replace(/^(.*)(@.*)$/, function (_, a, b) {
    return a.replace(/./g, '*') + b;
  });
}
//# sourceMappingURL=helpers.js.map